var QuestManager = {
	view :null,
	widget: null,
	isOpen: false,
	couting: null,
	quests:[],

	init: function() {
		AppEvent.on(player, "PLACE.LOADED", QuestManager.placeLoaded);
		this.sounds = {
			"complete": new AudioEffect("assets/audio/games/completed.mp3"),
		};

		this.player = Date.now() + "-" + Math.floor(Math.random() * 10000);

		setInterval(function() {QuestManager.widgetTick();}, 1000);
	},

	placeLoaded: function() {
		var pe = player.current;

		if (pe.quests.length > 0 && pe.quests[0].startsAt == player.ident) {
			if (QuestManager.findQuestById(pe.quests[0].id) == -1) QuestManager.viewQuest(pe.quests[0]);
		}
	},

	load: function(id) {
		$.getJSON("/html5/questloader.php?id=" + id).then(function(response) {
			QuestManager.viewQuest(response);
		});
	},

	closeViewQuest: function() {
		QuestManager.view.remove();
	},

	viewQuest: function(q) {
		QuestManager.quest = q;

		console.log(QuestManager.quest);

		var oldq = {};
		var found = QuestManager.findQuestById(q.id);

		if (found != -1) {
			oldq = q;
			q = QuestManager.quests[found];
			if (q.done != undefined) {
				QuestManager.complete(q);
				return;
			}
		}

		QuestManager.view = $(TPL.render("quest-main", {"short": q.short, "title": q.name, "info": q.info, "help": q.help}));
		$("#panels").append(QuestManager.view);

		SpeechManager.enableSpeech(".quest", ".speaks", 0, "TOPMENU");

		if (found != -1) {
			QuestManager.view.find(".qproceed").hide();
			QuestManager.view.find(".qrestart").show();
		}

		QuestManager.view.find(".qclose").click(function() {
			QuestManager.closeViewQuest();
		});

		QuestManager.view.find(".qrestart").click(function() {
			Equipment.resetQuestItems(q);
			ItemState.resetStates(q);
			QuestManager.quests.splice(found, 1);			
			QuestManager.quests.push(oldq);
			QuestManager.closeViewQuest();
			QuestManager.showWidget();
			HotSpotManager.clearRenderables();
			HotSpotManager.addRenderables(player.currentView.properties.collectibles, 'collectible');			
		});

		QuestManager.view.find(".qproceed").click(function() {

			if (found == -1) {
				QuestManager.quests.push(q);
				QuestManager.closeViewQuest();
				QuestManager.showWidget();

				if (QuestManager.quest.startsAt != player.ident) player.go(QuestManager.quest.startsAt);

				HotSpotManager.clearRenderables();
				HotSpotManager.addRenderables(player.currentView.properties.collectibles, 'collectible');
			}
		});		
		QuestManager.view.show();
	},

	showWidget: function() {
		var pending = "";
		var count = 0;
		for(var q in QuestManager.quests) {
			var quest = QuestManager.quests[q];
			if (quest.done == undefined) {
				quest.collected = 0;
				quest.total = parseInt(quest.total);
				quest.startedAt = new Date();
				quest.time = "00:00:00";
				pending += "<div id='quest-" + quest.id + "'>" + TPL.render("quest-short", {"no": parseInt(q) + 1, "quest": quest}) + "</div>";
				count ++;
			}
		}
		
		if (QuestManager.widget != undefined) QuestManager.widget.remove();

		if (count > 0) {
			QuestManager.widget = $(TPL.render("quest-widget", {"count": count, "pending": pending}));
			$("#panels").append(QuestManager.widget);
		}
	},

	findQuestById: function(id) {
		for(var q in QuestManager.quests) {
			if (QuestManager.quests[q].id == id) return q;
		}

		return -1;
	},

	widgetTick: function() {
		for(var q in QuestManager.quests) {
			if (QuestManager.quests[q].tracktime == "1") {
				QuestManager.refreshQuest(q);
			}
		}
	},

	action: function(type, item) {
		var q = QuestManager.findQuestById(item.collection_id);

		if (type == 'collected') {
			if (QuestManager.quests[q].logic == 'pickup.items') {
				QuestManager.quests[q].collected ++;
				if (QuestManager.quests[q].collected >= parseInt(QuestManager.quests[q].tocollect)) QuestManager.complete(QuestManager.quests[q]);

				QuestManager.refreshQuest(q);
				return false;
			}
		}

		if (type == 'delivered') {
			if (QuestManager.quests[q].logic == 'deliver.items') {
				QuestManager.quests[q].collected ++;
				if (QuestManager.quests[q].collected >= parseInt(QuestManager.quests[q].tocollect)) QuestManager.complete(QuestManager.quests[q]);

				QuestManager.refreshQuest(q);
			}
		}

		return true;
	},

	complete: function(q) {
		if (q.done == undefined) {
			var cd = new Date();
			q.timespent = Math.round((cd.getTime() - q.startedAt.getTime()) * 0.001);
			q.points = 1;
		}

		q.done = true;
		QuestManager.showWidget();

		QuestManager.victory = $(TPL.render("quest-victory", {"quest": q}));

		QuestManager.sounds.complete.play();
		$("#panels").append(QuestManager.victory);
		if (q.saved) $(".quest-victory .vsaverank").hide();

		QuestManager.victory.find(".vclose").click(function() {
			QuestManager.victory.remove();
		});

		QuestManager.victory.find(".vsaverank").click(function() {
			QuestManager.savenick(q);
		});
		QuestManager.victory.find(".vranking").click(function() {
			QuestManager.showranking(q);
		});
	},

	savenick: function(q) {
		QuestManager.saverank = $(TPL.render("quest-saverank", {"quest": q}));

		$("#panels").append(QuestManager.saverank);

		$("#quest-nick").on("keydown", function() {
			$("#quest-nick").removeClass("error");
		});

		$("#quest-email").on("keydown", function() {
			$("#quest-email").removeClass("error");
		});

		QuestManager.saverank.find(".vsaverank").click(function() {
			var nick = $("#quest-nick").val();
			var email = $("#quest-email").val();
			var ident = QuestManager.player;

			$("#quest-nick").removeClass("error");
			$("#quest-email").removeClass("error");
			ssi("Quest","addToRanking",{"quest_id": q.id, "ident": ident, "nick": nick, "email": email, "points": q.points, "time": q.timespent},function(resp) {
				if (resp.data.status == 'invalid') {
					if (resp.data.errors['nick'] != undefined) {
						$("#quest-nick").addClass("error");
					}
					if (resp.data.errors['email'] != undefined) {
						$("#quest-email").addClass("error");
						setTimeout(function() {$("#quest-nick").removeClass("error");}, 2000);
					}
				} else {
					q.saved = true;
					QuestManager.saverank.remove();
					$(".quest-victory .vsaverank").hide();
				}
			});

		});

		QuestManager.saverank.find(".vclose").click(function() {
			QuestManager.saverank.remove();
		});
	},

	showranking: function(q) {
		QuestManager.ranking = $(TPL.render("quest-ranking", {"quest": q}));

		$("#panels").append(QuestManager.ranking);

		ssi("Quest","info",{"id": q.id}, function(resp) {
			var res = "<tr><th>#</th><th>Nick</th><th>Czas</th></tr>";

			for(var r in resp.data.ranking) {
				var rank = resp.data.ranking[r];

				var dt = parseInt(rank.time);
				var time = this.ddigit(Math.floor(dt / 3600)) + ":" + this.ddigit(Math.floor(dt / 60)) + ":" + this.ddigit(dt % 60);

				res += "<tr>";
				res += "<td>" + (parseInt(r) + 1) + "</td>";
				res += "<td>" + rank.nick + "</td>";
				res += "<td>" + time + "</td>";
				res += "</tr>";
			}

			$("#quest-ranks").html(res);
		}.bind(this));


		QuestManager.ranking.find(".vclose").click(function() {
			QuestManager.ranking.remove();
		});
	},

	ddigit: function(d) {
		if (d < 10) return "0" + d;
		return d;
	},

	refreshQuest: function(n) {
		var cd = new Date();
		var q = QuestManager.quests[n];

		if (q.done == undefined) {
			var dt = Math.round((cd.getTime() - q.startedAt.getTime()) * 0.001);
			q.time = this.ddigit(Math.floor(dt / 3600)) + ":" + this.ddigit(Math.floor(dt / 60)) + ":" + this.ddigit(dt % 60);
		}

		$("#quest-" + q.id).html(TPL.render("quest-short", {"no": parseInt(n) + 1, "quest": q}));
	},

	placeReady: function(pe) {
	},
}

PluginManager.add(QuestManager);